import React from 'react'
import styles from './UpgradeModal.scss'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { CTA } from 'common/styleguide/CTA'
import _ from 'lodash'
import { getCurrentUser } from 'lib/utils'
import { FormattedMessage as T, defineMessages } from 'react-intl'
import { Msg, commonCTAs, useFormatMessage } from 'lib/localization'
import { names, descriptions, featureData } from './features'

export const UPGRADE_MODAL = 'UPGRADE_MODAL'

export const messages = defineMessages({
  createAccount: {
    id: 'UpgradeModal.createAccount',
    defaultMessage: 'Create an Account'
  }
})

const context = require.context('./img', false, /.*/)

const asset = (name, ext) => context(`./${name}.${ext}`)

export const UpgradeModal = props => {
  const fm = useFormatMessage()
  const { onRequestClose, showUpgradeButton, feature } = props
  const hasUser = !!_.get(window, 'rwgps.config.currentUser.id')
  const upgradeButton = showUpgradeButton === undefined ? true : showUpgradeButton
  const data = featureData[feature]
  if (!data) { throw Error(`Unknown UpgradeModal feature "${feature}"`) }
  const { assetType, helpPath } = data
  const name = _.startCase(fm(names[feature]))
  const description = fm(descriptions[feature])
  const upgradePath = `/subscriptions/new?account_level=premium${getCurrentUser().eligibleForOnetimeTrial ? '&trial=1' : ''}`
  const upgradeText = <Msg m={getCurrentUser().eligibleForOnetimeTrial ? commonCTAs.startFreeTrial : commonCTAs.upgradeNow} />
  const video = (assetType === 'webm')

  const redirectParam = `redirect_to=${encodeURIComponent(window.location.href)}`

  const bigCTA = hasUser
    ? <CTA href={upgradePath}>{upgradeText}</CTA>
    : <CTA href={`/signup?${redirectParam}`}>{fm(messages.createAccount)}</CTA>

  return (
    <ModalOverlay contentPadding={false} maxWidth='875px' onRequestClose={onRequestClose} shouldCloseOnOverlayClick>
      <div className={styles.UpgradeModal}>
        <div className={styles.assetContainer}>
          {video &&
            <video autoPlay loop>
              <source src={asset(feature, 'mp4')} type={`video/mp4`} /> }
              <source src={asset(feature, 'webm')} type={`video/webm`} /> }
            </video>}
          { !video && <img src={asset(feature, assetType)} /> }
        </div>
        <div className={styles.descriptionContainer}>
          <h2 className={styles.title}>{name}</h2>
          <p className={styles.description}>{description}</p>
          { upgradeButton && bigCTA }
          <a className={styles.learnMore} href={helpPath}>
            <T
              id='UpgradeModal.learnMoreAbout'
              defaultMessage='Learn more about {featureName}'
              values={{ featureName: name }} />
          </a>
        </div>
      </div>
    </ModalOverlay>
  )
}
